import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'

//添加全局样式
import'./assets/css/global.css'
//引入iconfont
import './assets/font/iconfont.css'


//导入axios
import axios from 'axios'

import './plugins/charts.js'

//挂载axios
Vue.prototype.$http=axios
//设置axios的基础路径
axios.defaults.baseURL = process.env.VUE_APP_BASE_API;

axios.interceptors.request.use(config => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  if (user && user.access_token) {
    config.headers.Authorization = "Bearer " + user.access_token;
  }
  return config;
});


Vue.config.productionTip = false


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
